module.exports = __webpack_public_path__ + "img/dombitcom.jpg?61cc0abbb3a5998db7ef8a2ce3b8f6ac";